// Soumet une action non-GET (post / patch / delete) depuis un composant bridge,
// par un formulaire injecté que Turbo traite comme n'importe quel formulaire de
// la page : `_method` pour le verbe, le jeton CSRF de la page, puis retrait du
// DOM. Partagé par bridge--menu, bridge--button et bridge--list-actions — la
// même recette était recopiée dans les trois, et y divergeait.
//
// `haptic` : le type de retour haptique, posé sur le formulaire pour que
// bridge--haptic le lise au turbo:submit-end (cf. son contrôleur pour les types).
export function submitForm(url, method, { haptic } = {}) {
  const form = document.createElement('form')
  form.action = url
  form.method = 'post'
  form.dataset.turbo = 'true'
  if (haptic) form.dataset.haptic = haptic

  const methodField = document.createElement('input')
  methodField.type = 'hidden'
  methodField.name = '_method'
  methodField.value = method

  const csrfField = document.createElement('input')
  csrfField.type = 'hidden'
  csrfField.name = 'authenticity_token'
  csrfField.value = document.querySelector("meta[name='csrf-token']")?.content ?? ''

  form.append(methodField, csrfField)
  document.body.appendChild(form)
  // Retrait après coup, pas juste après requestSubmit() : Turbo redirige
  // turbo:submit-end vers <html> quand le formulaire n'est plus connecté
  // (cf. son helper dispatch), et bridge--haptic n'y lirait aucun data-haptic.
  form.addEventListener('turbo:submit-end', () => form.remove(), { once: true })
  form.requestSubmit()
}
